import { useCallback } from 'react';
import { useHistory as useReactRouterHistory } from 'react-router-dom';
import { LocationDescriptor } from 'history';

const STATE_FROM: string[] = [];

export const useCustomHistory = () => {
  const history = useReactRouterHistory();

  const push = useCallback(
    (location: LocationDescriptor, skipPushToStateFrom = false) => {
      if (!skipPushToStateFrom) {
        STATE_FROM.push(`${window.getPathname()}${window.location.search}`);
      }

      history.push(location);
    },
    []
  );

  const getFrom = useCallback(() => {
    return STATE_FROM.pop();
  }, []);

  const goBack = useCallback((fallbackUrl: string) => {
    const fromUrl = getFrom();
    history.push(fromUrl || fallbackUrl);
  }, []);

  return { history, push, getFrom, goBack, location: history.location };
};
